export default __webpack_public_path__ + "static/media/ba22.a5c0659f.jpg";